export default {
  allergy: 'ALLERGY',
  procedures: 'PROCEDURE',
  diagnosis: 'DIAGNOSIS',
  medication: 'MEDICATION',
  vaccination: 'VACCINATION',
  procedureKinds: 'PKINDS',
  labKinds: 'LABKINDS',
  providers: 'PROVIDERS',
  reports: 'REPORTS',
  directives: 'DIRECTIVES'
}
